
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { MarketPageProps } from './MarketPage.types';
import { PageWrapper } from '@otomoro/components/layout/PageWrapper';
import { Headline } from '@otomoro/components/shared/Headline';
import { FlexibleContent, FlexibleContentProps } from '@otomoro/components/shared/FlexibleContent';
export default function MarketPage({ data }: MarketPageProps) {
    if (!data) {
        return (<div className="text-center">
				Please start editing your Market document to see the preview!
			</div>);
    }
    return (<PageWrapper noPb>
			<Headline size="large" theme="light" border headlineText={data.headline} subheadline={data.subHeadline} healineSize="42px"></Headline>
			<FlexibleContent blocks={data.flexibleContent as FlexibleContentProps['blocks']}/>
		</PageWrapper>);
}

    async function __Next_Translate__getStaticProps__197a63bd5dd__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'components//market/MarketPage',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__197a63bd5dd__ as getStaticProps }
  